(function () {
    'use strict';

    let isOpen = false;
    let backdrop = null;
    let customDropdown, dropdownSelected, dropdownOptions, selectedText;
    let hasUserSelected = false;

    function initDropdown() {
        customDropdown = document.querySelector('.custom-dropdown');
        dropdownSelected = document.getElementById('dropdownSelected');
        dropdownOptions = document.getElementById('dropdownOptions');
        selectedText = dropdownSelected ? dropdownSelected.querySelector('.selected-text') : null;

        if (!customDropdown || !dropdownSelected || !dropdownOptions) return;

        requestAnimationFrame(() => {
            if (!hasUserSelected) {
                const firstOption = document.querySelector('.dropdown-option[data-selected="true"]');
                if (firstOption) {
                    const categoryId = firstOption.getAttribute('data-value');
                    manualSectionToggle(categoryId);
                }
            }
        });

        showFirstSection();
        attachEventListeners();
        initStarRatings();
    }

    function showFirstSection() {
        const firstOption = document.querySelector('.dropdown-option[data-selected="true"]');
        if (firstOption) {
            const firstCategoryId = firstOption.getAttribute('data-value');
            manualSectionToggle(firstCategoryId);
        }
    }

    function toggleDropdown() {
        isOpen = !isOpen;
        customDropdown.classList.toggle('open', isOpen);

        if (isOpen) {
            createBackdrop();
        } else {
            removeBackdrop();
        }
    }

    function closeDropdown() {
        isOpen = false;
        if (customDropdown) {
            customDropdown.classList.remove('open');
        }
        removeBackdrop();
    }

    function createBackdrop() {
        backdrop = document.createElement('div');
        backdrop.className = 'dropdown-backdrop';
        backdrop.style.cssText = `
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            z-index: 999;
            background: transparent;
        `;
        document.body.appendChild(backdrop);
        backdrop.addEventListener('click', closeDropdown);
    }

    function removeBackdrop() {
        if (backdrop) {
            backdrop.remove();
            backdrop = null;
        }
    }

    function selectOption(option) {
        hasUserSelected = true;
        closeDropdown();

        setTimeout(() => {
            const allOptions = document.querySelectorAll('.dropdown-option');
            allOptions.forEach(opt => opt.removeAttribute('data-selected'));

            option.setAttribute('data-selected', 'true');
            if (selectedText) {
                selectedText.textContent = option.textContent;
            }

            const selectedProduct = option.getAttribute('data-value');
            manualSectionToggle(selectedProduct);
        }, 0);
    }

    function manualSectionToggle(categoryId) {
        // Hide all sections + destroy slick
        const allSections = document.querySelectorAll('.reviews-carousel[data-category-id]');
        allSections.forEach(section => {
            const wrapper = section.closest('.shopify-section');
            if (wrapper) {
                const $carousel = $(section).find('.carousel-container');
                if ($carousel.hasClass('slick-initialized')) {
                    $carousel.slick('unslick');
                }
                wrapper.style.display = 'none';
            }
        });

        // Show + init only selected section
        const matchingSection = document.querySelector(`.reviews-carousel[data-category-id="${categoryId}"]`);
        if (matchingSection) {
            const sectionWrapper = matchingSection.closest('.shopify-section');
            if (sectionWrapper) {
                sectionWrapper.style.display = 'block';

                setTimeout(() => {
                    const $carousel = $(matchingSection).find('.carousel-container');
                    if ($carousel.length && $carousel.children().length > 0) {
                        if ($carousel.hasClass('slick-initialized')) {
                            $carousel.slick('unslick');
                        }
                        $carousel.slick({
                            infinite: false,
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            arrows: true,
                            dots: true,
                            centerMode: false,
                            customPaging: (slider, index) => (
                                '<button type="button" class="slick-dot">' + (index + 1) + '</button>'
                            ),
                            prevArrow: '<button type="button" class="slick-prev">Prev</button>',
                            nextArrow: '<button type="button" class="slick-next">Next</button>'
                        });
                    }
                }, 50);
            }
        }
    }

    function initStarRatings() {
        const allSections = document.querySelectorAll('.reviews-carousel');
        for (let i = 0; i < allSections.length; i++) {
            const section = allSections[i];
            const ratingElement = section.querySelector('.parent-rating');
            const rating = ratingElement ? parseFloat(ratingElement.textContent || 0) : 0;
            const starInner = section.querySelector('.star-inner');
            if (starInner) {
                starInner.style.width = ((rating / 5) * 100) + '%';
            }
        }
    }

    function attachEventListeners() {
        dropdownSelected.addEventListener('click', function (e) {
            e.stopPropagation();
            toggleDropdown();
        });

        dropdownOptions.addEventListener('click', function (e) {
            if (e.target.classList.contains('dropdown-option')) {
                e.preventDefault();
                e.stopPropagation();
                selectOption(e.target);
            }
        });

        document.addEventListener('click', function (e) {
            if (!customDropdown.contains(e.target)) {
                closeDropdown();
            }
        });

        document.addEventListener('keydown', function (e) {
            if (e.key === 'Escape' && isOpen) {
                closeDropdown();
            }
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initDropdown);
    } else {
        initDropdown();
    }

})();
